import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { api_path } from "../../shared";
import MainContactForm from "./MainContactForm.jsx";
import SubContactForm from "./SubContactForm.jsx";
import ServiceUse from "./ServiceUse.jsx";
export function LeadsDetailContent(props) {
     const navigate = useNavigate();
      const goBack = () => {
          navigate(-1);
        };
    const getUserID = JSON.parse(localStorage.getItem('USER_ID'));  
  const [searchParams] = useSearchParams();
  const [SubjectName, setSubjectName] = useState();
  const id = searchParams.get("id");
  const [isDisabled, setDisabled] = useState(false);

  useEffect(() => {//run always
  
  });
  useEffect(() => {//run when id Change value. 
    if(id>0){
      setSubjectName("Edit Customer")
        fetch(api_path + "/TS_SALES_ORDER.php?order_id=" + id)
              .then((res) => res.json())
              .then((res) => {
                const array = res;
                for (const i of array) {

                }

              });
    }else{
      setSubjectName("Customer")
    }
  }, [id]);
  const [value, setValue] = React.useState("1");
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Container maxWidth="lg">
   
  <Grid container spacing={2}>
       <Grid container spacing={2}>
       <br/><br/><br/>
        </Grid>
        <Grid container spacing={2}>
          <label className="head">{SubjectName}</label>
        </Grid>
<SubContactForm 
                CUSTOMER_CODE={id}
                PROFILE_TYPE={2}/>
    
                         <MainContactForm 
            CUSTOMER_CODE={id}/>
                    
                 
                           
                     
        {/* <Box sx={{ width: "100%", typography: "" }}>
          <TabContext value={value}>
          <Box
              sx={{
                borderBottom: 3,
                borderColor: "rgb(0, 120, 212)",
                paddingTop: 1,
              }}
            > */}
              {/*   <TabList
                onChange={handleChangeTab}
                 sx={{
                  "& .Mui-selected": {
                    backgroundColor: "rgb(0, 120, 212)",
                    color: "white",
                    " &.css-3gr6th-MuiButtonBase-root-MuiTab-root.Mui-selected":
                      { color: "white" },
                    " &.css-t373k1.Mui-selected": { color: "white" },
                  },
                }}
              >
                  <Tab label="Main Profile" value="1" />
                  <Tab label="Last 10 Shipment of customer" value="2" />
                  <Tab label="Sales in charge" value="3" />
              <Tab label="Contact for CS" value="2" />
                <Tab label="Contact for Document" value="3" />
                <Tab label="Contact for Account" value="4" />
                <Tab label="Others" value="5" /> 
              </TabList>*/}
            {/* </Box>
            <TabPanel value="1"> */}
                     {/* <Grid item xs={12} sm={6}>
                         <MainContactForm 
            CUSTOMER_CODE={id}/>
                      </Grid>
                       <Grid item xs={12} sm={6}>
                           <SubContactForm 
                CUSTOMER_CODE={id}
                PROFILE_TYPE={2}/>
                      </Grid> */}
         
     
           
 
            {/* </TabPanel>
            <TabPanel value="2">
              <SubContactForm 
                CUSTOMER_CODE={id}
                PROFILE_TYPE={2}/>
            </TabPanel>
            <TabPanel value="3">
            <SubContactForm 
              CUSTOMER_CODE={id}
              PROFILE_TYPE={3}/>
            </TabPanel>
            <TabPanel value="4">
            <SubContactForm 
              CUSTOMER_CODE={id}
              PROFILE_TYPE={4}/>
            </TabPanel>
            <TabPanel value="5">
            <SubContactForm 
              CUSTOMER_CODE={id}
              PROFILE_TYPE={5}/>
            </TabPanel>
          </TabContext>
        </Box> */}


        </Grid>
       
       
    
    </Container>
  );
}
